/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-17 11:21:45
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-18 17:56:49
 * @FilePath: /unifyxp-v2-store-portal/src/components/Modules/Components/ContentImageDragItem/index.tsx
 */
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import React from 'react';
import { Input, Select, TextArea } from 'src/components/Antd';
import Image from 'src/components/DragRowDisplay/Image';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const ContentDragItem = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    index,
    contentPageList,
    isList,
    summary,
    subtitle,
    image,
    contentPage = {},
    onDelete,
    onChange,
    specificError = {},
    errKeys = {},
    selectedPages,
    topPart,
    sectionContainer,
    isPrimary,
  } = props;

  //console.log('selectedPages', selectedPages);
  const { inUsePages = [] } = contentPageList || {};
  //console.log('content Page', selectedPages || inUsePages || []);
  const contentUuid = (contentPage || {}).uuid;

  const handleOnSubtitleChange = (subtitle) => {
    if (onChange) {
      onChange(index, { subtitle });
    }
  };

  const handleOnSummaryChange = (summary) => {
    if (onChange) {
      onChange(index, { summary });
    }
  };

  const handleOnImageChange = (image) => {
    if (onChange) {
      onChange(index, { image });
    }
  };

  const handleOnContentPageChange = (contentPageUuid) => {
    const { inUsePages, pendingPages, previousPages } = contentPageList || {};
    const list = selectedPages || [
      ...inUsePages,
      ...pendingPages,
      ...previousPages,
    ];
    const t = list.find((i) => i.uuid === contentPageUuid);

    if (onChange) {
      onChange(index, {
        contentPage: t,
        summary: (t.summary || '').slice(0, 120),
        // subtitle: (t.subtitle || '').slice(0, 40),
      });
    }
  };

  const handleOnDelete = () => {
    if (onDelete) {
      onDelete(index);
    }
  };

  const getErr = (key) => {
    //console.log(specificError);
    return specificError[errKeys[key]] || [];
  };

  return (
    <React.Fragment>
      <Section className={`${css.section} ${sectionContainer || ''}`}>
        {topPart || null}
        <Image
          onDelete={onDelete ? handleOnDelete : null}
          title={`${getI18n('general.checkImgDraggableDisplay.title')}*`}
          subtitle={`${getI18n('general.tiprecommendedratio')} 7:8`}
          imgOnChange={handleOnImageChange}
          linkImage={image}
          error={
            getErr(errKeys.image).length > 0
              ? getErr(errKeys.image).join(' ')
              : ''
          }
          topPart={
            <ItemWrapper
              title={`${getI18n('general.sider.contentPage')} ${index + 1}*`}>
              <Select
                placeholder={getI18n('general.selectContentPage')}
                disabled={!isPrimary}
                optionsList={(selectedPages || inUsePages || []).map((i) => {
                  const { uuid, name } = i;
                  return {
                    label: name,
                    value: uuid,
                  };
                })}
                value={contentUuid}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                } //contentPageInvalid
                showSearch
                optionFilterProp='label'
                onChange={handleOnContentPageChange}
                size='large'
                error={
                  getErr(errKeys.contentPage).length > 0 ||
                  getErr(errKeys.contentPageInvalid).length > 0
                }
                help={
                  getErr(errKeys.contentPage).join(' ') +
                  getErr(errKeys.contentPageInvalid).join(' ')
                }
              />
            </ItemWrapper>
          }
        />
        {!isList && (
          <ItemWrapper
            rightPart={
              <CountWords count={(subtitle || '').length} allCount={40} />
            }
            title={`${getI18n('general.contentPageSubtitle')}*`}>
            <Input
              size='large'
              maxLength={40}
              value={subtitle}
              onChange={handleOnSubtitleChange}
              error={getErr(errKeys.subtitle).length > 0}
              help={getErr(errKeys.subtitle).join(' ')}
            />
          </ItemWrapper>
        )}
        <ItemWrapper
          rightPart={
            <CountWords count={(summary || '').length} allCount={120} />
          }
          title={`${getI18n('general.contentPageSummary')}*`}>
          <TextArea
            maxLength={120}
            value={summary}
            onChange={handleOnSummaryChange}
            error={getErr(errKeys.summary).length > 0}
            help={getErr(errKeys.summary).join(' ')}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ContentDragItem;
